
import { maskNumber } from "../../../utils/helper";
import { useAgentManualCall } from "../../../hooks/useAgentManualCall/UseAgentManualCall";
import { useDoctorPatientCall } from "../../../hooks/useDoctorPatientCall/UseDoctorPatientCall";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { Icon } from "../../icon/Icon";
import style from "./phoneNumber.module.scss";

interface PhoneNumberCardProps {
  number: string;
  icon?: string;
  componentName: string;
  pocName?:string;
  name?:any;
  handleEditPoc?:any;
  otherNumber?: string;
  callType?: string;
}

export const PhoneNumberCard: React.FC<PhoneNumberCardProps> = ({
  number,
  icon,
  componentName,
  handleEditPoc,
  name,
  otherNumber = "",
  callType,
}) => {
  const { handleConnectCall } = useAgentManualCall();
  const { handleConnectCallBtwDP } = useDoctorPatientCall();
  return (

    <>
      <div className={style.poc_Card} >
       {componentName ==="POC"&& 
          <Container>
            <Text text={name} className={style.value} />
          </Container>}
        <div className={style.flex} onClick={() => (otherNumber && componentName === "doctorCard") ? handleConnectCallBtwDP(otherNumber, number) : handleConnectCall(number)}>
          <Container className={componentName === "doctorCard" ? style.doctor_icon : style.icon}>
            <Icon
              className={componentName==="doctorCard"?style.doctor_img:style.img}
              src={"/images/phone.png"}
              alt="phoneIcon"
            />
          </Container>
          <Container>
            <Text text={(otherNumber && componentName === "doctorCard") ? (callType || "DOC -> PAT") : componentName === "POC" ? number : maskNumber(number)} className={componentName === "doctorCard" ? style.doctorCard : style.value} />
          </Container>
        </div>
        {componentName === "POC" && <div onClick={handleEditPoc}>
          <Icon className={style.edit_img} src={"/images/edit.png"} alt="EditIcon" />
        </div>}
      </div>
    </>
  );
};
